import CoreCompatibilityModal from 'marketplace-ui-common/compatibility/components/FeatureCompatibilityModal';
import unescapedText from 'I18n/utils/unescapedText';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useCompatibility } from 'marketplace-ui-common/compatibility/hooks/useCompatibility';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureCompatibilityModal = ({
  appContext,
  onClose,
  assetScopes,
  offeringType,
  trackInteraction
}) => {
  const scopeFeatures = assetScopes.reduce((acc, scope) => {
    const scopeFeatureI18nKey = `marketplace-assets-ui.scopeFeatures.${scope}-title`;
    if (isValidI18nKey(scopeFeatureI18nKey)) {
      const feature = {
        text: unescapedText(scopeFeatureI18nKey),
        scopes: [scope]
      };
      return acc.concat(feature);
    }
    return acc;
  }, []);
  const tierGroupNames = ['CRM', 'CONTENT', 'MARKETING', 'OPERATIONS', 'SALES', 'SERVICE'];
  const {
    compatibilityRequestState,
    featuresWithTierCompatibility,
    portalTiers
  } = useCompatibility({
    appContext,
    offeringType,
    scopeFeatures,
    tierGroupNames
  });
  return /*#__PURE__*/_jsx(CoreCompatibilityModal, {
    appContext: appContext,
    featuresWithTierCompatibility: featuresWithTierCompatibility,
    offeringType: offeringType,
    onClose: onClose,
    portalTiers: portalTiers,
    requestState: compatibilityRequestState,
    tierGroupNames: tierGroupNames,
    trackInteraction: trackInteraction
  });
};